import React from 'react';
import { 
  MdPlayCircleOutline,
  MdOutlineShield,
  MdOutlineAccountBalanceWallet,
  MdAttachMoney,
  MdLocalOffer
} from 'react-icons/md';

const KeyFeatures = ({ language = 'en', isEnabledAudioGuide, onOptAudioSelect }) => {
    const screenWidth = window.innerWidth - 20;

    const keyFeaturesData = [
        {
            key: "AUDIO",
            name: { en: 'Audio Guide Included', kn: 'ಆಡಿಯೋ ಮಾರ್ಗದರ್ಶಿ' },
            desc: { en: 'Play Sample', kn: 'ಮಾದರಿಯನ್ನು ಪ್ಲೇ ಮಾಡಿ' },
            icon: 'play-circle-outline',
            isEnabled: isEnabledAudioGuide,
            sequence: 2,
            component: <MdPlayCircleOutline className="text-2xl text-gray-700" />
        },
        {
            name: { en: '100% Guaranteed Ride', kn: '100% ಗ್ಯಾರಂಟಿ ಸವಾರಿ' },
            desc: { en: '', kn: '' },
            icon: 'shield-check-outline',
            isEnabled: true,
            sequence: 3,
            component: <MdOutlineShield className="text-2xl text-gray-700" />
        },
        {
            name: { en: 'Multiple Driver Bidding', kn: 'ಡ್ರೈವರ್ ಬಿಡ್ಡಿಂಗ್' },
            desc: { en: '', kn: '' },
            icon: 'account-cash-outline',
            isEnabled: true,
            sequence: 1,
            component: <MdOutlineAccountBalanceWallet className="text-2xl text-gray-700" />
        },
        {
            name: { en: 'Save 1500', kn: '1500 ಉಳಿಸಿ' },
            desc: { en: '', kn: '' },
            icon: 'cash-multiple',
            isEnabled: false,
            sequence: 4,
            component: <MdAttachMoney className="text-2xl text-gray-700" />
        },
        {
            name: { en: '5% Off', kn: '5% ರಿಯಾಯಿತಿ' },
            desc: { en: '', kn: '' },
            icon: 'sale',
            isEnabled: false,
            sequence: 5,
            component: <MdLocalOffer className="text-2xl text-gray-700" />
        },
    ];

    const features = keyFeaturesData
        .filter(f => f.isEnabled)
        .sort((a, b) => a.sequence - b.sequence);

    const itemWidth = features.length > 0 ? `${100 / features.length}%` : '100px';

    const renderItem = (item, index) => {
        const isAudioItem = item.key === 'AUDIO';
        return (
            <button
                key={index}
                className="flex flex-col items-center justify-start px-2 py-1"
                style={{ width: itemWidth }}
                onClick={() => {
                    if (isAudioItem) {
                        onOptAudioSelect?.();
                    }
                }}
                disabled={!isAudioItem}
                // style={{ 
                //     cursor: isAudioItem ? 'pointer' : 'default',
                //     minWidth: '80px' // Ensure minimum width for small screens
                // }}
            >
                {item.component}
                <p className="font-bold mt-1.5 text-xs text-center text-gray-700">
                    {item.name[language] || item.name.en}
                </p>
                {item.desc[language] || item.desc.en ? (
                    <p className="font-bold -mt-1 text-xs text-center text-red-500">
                        {item.desc[language] || item.desc.en}
                    </p>
                ) : null}
            </button>
        );
    };

    return (
        <div className="mt-1 py-1 rounded bg-gray-100">
            <div className="flex w-full">
                {features.map((item, index) => renderItem(item, index))}
            </div>
        </div>
    );
};

export default KeyFeatures;